<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="电梯停保"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <h6>提示:电梯停保后，无法维修、保养、报修，电梯日扣费暂停计费</h6>
      <h4>电梯信息</h4>
      <ul>
        <li>使用单位：{{editData.propertyUnitName}}</li>
        <li>项目名称：{{editData.projectName}}</li>
        <li>电梯位置：{{editData.liftLocation}}</li>
      </ul>
      <h4>删除工单</h4>
      <h6>提示:删除工单选择【是】,将删除电梯相关的维修、保养、巡查工单。</h6>
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="删除工单：" class="input-with-col2 mr0">
          <el-select
            size="mini"
            v-model="form.deleteOrderStatus"
            value-key="dictionaryCode"
          >
            <el-option
              v-for="item in deleteOrderStatusList"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注信息：" class="input-with-col2 mr0">
          <el-input
            size="mini"
            v-model.trim="form.remark"
            placeholder="备注信息"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { stopMaintain } from "@/api/ElevatorManagement";
export default {
  data() {
    return {
      deleteOrderStatusList: [
        {
          dictionaryCode: 1,
          dictionaryValue: '删除'
        },
        {
          dictionaryCode: 2,
          dictionaryValue: '不删除'
        }
      ],
      form: {
        remark: '',
        deleteOrderStatus: ''
      },
      rules: {
        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false,
    };
  },
  props: {
    editData: {
      type: Object,
      default: {}
    }
  },
  created() {},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const queryData = { ...this.form };
          queryData.liftId = this.editData.id;
          const res = await stopMaintain(queryData);
          if (res.code === 200) {
            this.$message.success("停保成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
h6 {
  margin-bottom: 10px;
}
ul {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ElevatorManagement/components/StopMaintain.vue